/* =============================================================================
 * Competition facts shown on the home page and registration screen.
 * EDIT THIS FILE when dates are finalised — `null` shows
 * "लवकरच जाहीर होईल" (to be announced) on the site.
 * Dates are YYYY-MM-DD.
 * ========================================================================== */

export const COMPETITION = {
  name: "शिवकथाकार श्री. विजयराव देशमुख शिव-वक्ता स्पर्धा",
  /** Home page hero title only — split across two lines. Elsewhere `name` is used as one line. */
  homeTitleLine1: "शिवकथाकार श्री. विजयराव देशमुख",
  homeTitleLine2: "शिव-वक्ता स्पर्धा",
  season: "२०२६-२७",
  organiser: "छत्रपती सेवा प्रतिष्ठान, नागपूर-पुणे",
  /** One-line description under the title. TODO: confirm wording. */
  tagline:
    "छत्रपती शिवरायांचे चरित्र, विचार व कार्य यांवर आधारित राज्यस्तरीय वक्तृत्व स्पर्धा ",

  registrationOpens: "2026-10-11" as string | null, // e.g. '2026-10-15'
  registrationCloses: "2026-11-20" as string | null, // e.g. '2026-11-05'
  firstRoundDate: null as string | null, // also used on the results page

  // Registration is free for every group — there is no fee setting on purpose.
};

/**
 * The four rounds (DESIGN.md: 5,000 → 300 → 50 → 10 funnel).
 * TODO: confirm the level/venue wording for each round.
 */
export const ROUNDS = [
  {
    name: "पहिली फेरी",
    text: "सर्व नोंदणीकृत स्पर्धक विविध केंद्रांवर सहभागी होतील.",
  },
  { name: "दुसरी फेरी", text: "पहिल्या फेरीतून निवडलेले स्पर्धक." },
  { name: "तिसरी फेरी", text: "दुसऱ्या फेरीतून निवडलेले स्पर्धक." },
  { name: "अंतिम फेरी", text: "अंतिम स्पर्धक व पारितोषिक वितरण." },
];
